export const POST_TYPE_TICKER = 'ticker'

export const POST_TYPE_POST = 'post'

export const POST_LIST_API_PAGE_SIZE = 10

export const POST_LIST_API_PARAMS = { size: POST_LIST_API_PAGE_SIZE }
